.root {
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  font-size: var(--text-fz, var(--mantine-font-size-md));
  line-height: var(--text-lh, var(--mantine-line-height-md));
  font-weight: var(--mantine-font-weight-regular);
  text-wrap: var(--text-text-wrap, var(--mantine-text-wrap, wrap));
  margin: 0;
  padding: 0;

  &:where([data-truncate]) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:where([data-truncate='start']) {
    direction: rtl;
    text-align: end;

    @mixin where-rtl {
      direction: ltr;
      text-align: start;
    }
  }

  &:where([data-variant='gradient']) {
    background-image: var(--text-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &:where([data-line-clamp]) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: var(--text-line-clamp);
    -webkit-box-orient: vertical;
  }

  &:where([data-inherit]) {
    line-height: inherit;
    font-weight: inherit;
    font-size: inherit;
  }

  &:where([data-inline]) {
    line-height: 1;
  }
}
